import axios from 'axios'

export default {
  delete: async (sitePath, id) => {
    const url = `${sitePath}/department/${id}/`
    const response = await axios.delete(url)

    return response.data
  },

  get: async (sitePath, id) => {
    const url =
      id === undefined
        ? `${sitePath}/department/`
        : `${sitePath}/department/${id}/`

    const response = await axios.get(url)

    return response.data
  },

  post: async (sitePath, data) => {
    const url = `${sitePath}/department/`
    const response = await axios.post(url, data)

    return response.data
  },

  put: async (sitePath, id, data) => {
    const url = `${sitePath}/department/${id}/`
    // const response = await axios.put(url, data)
    const response = await axios({
      method: 'put',
      url: url,
      data: data,
      config: { headers: { 'Content-Type': 'multipart/form-data' } },
    })
    return response.data
  },
}
